export default {
  en: {
    'about-us':
      'https://intereact.customerly.help/intereact-policies-and-terms-of-service/about-intereact',
    'terms-of-service':
      'https://intereact.customerly.help/intereact-policies-and-terms-of-service/terms-of-service',
    'privacy-policy':
      'https://intereact.customerly.help/intereact-policies-and-terms-of-service/privacy-policy',
    'free-for-all-policy':
      'https://intereact.customerly.help/intereact-policies-and-terms-of-service/free-for-all-policy-and-payment-terms-of-service',
  },
  it: {
    'about-us':
      'https://intereact.customerly.help/politiche-e-termini-di-servizio-di-intereact/informazioni-su-intereact',
    'terms-of-service':
      'https://intereact.customerly.help/politiche-e-termini-di-servizio-di-intereact/termini-di-servizio',
    'privacy-policy':
      'https://intereact.customerly.help/politiche-e-termini-di-servizio-di-intereact/politica-sulla-privacy',
    'free-for-all-policy':
      'https://intereact.customerly.help/politiche-e-termini-di-servizio-di-intereact/gratuito-per-tutte-le-politiche-e-i-termini-di-servizio-di-pagamento',
  },
};
